import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const Icon = props =>
  <SvgIcon viewBox="0 0 80 80" {...props}>
    <path d="M29.298 63.47l-4.048 4.02c-3.51 3.48-9.216 3.482-12.723 0-1.686-1.672-2.612-3.894-2.612-6.256s.927-4.585 2.61-6.258l14.9-14.783c3.09-3.062 8.898-7.57 13.132-3.372 1.943 1.93 5.08 1.918 7.01-.024 1.93-1.942 1.918-5.08-.025-7.01-7.197-7.14-17.834-5.82-27.098 3.37l-14.9 14.785C1.967 51.49 0 56.21 0 61.235s1.968 9.743 5.544 13.292C9.224 78.176 14.054 80 18.887 80c4.834 0 9.667-1.824 13.348-5.476l4.05-4.02c1.943-1.93 1.954-5.067.024-7.01-1.928-1.94-5.07-1.952-7.012-.023zM74.454 6.045c-7.73-7.67-18.538-8.086-25.694-.986l-5.046 5.01c-1.943 1.928-1.955 5.065-.025 7.008s5.067 1.954 7.01.025l5.044-5.005c3.707-3.68 8.56-2.155 11.727.986 1.69 1.674 2.616 3.897 2.616 6.26 0 2.362-.928 4.585-2.613 6.258l-15.897 15.77c-7.27 7.212-10.68 3.827-12.134 2.383-1.943-1.928-5.08-1.916-7.01.026s-1.918 5.08.025 7.01c3.337 3.31 7.146 4.953 11.14 4.953 4.888 0 10.052-2.463 14.962-7.338l15.896-15.77C78.03 29.082 80 24.362 80 19.338c0-5.022-1.97-9.743-5.546-13.294z" />
  </SvgIcon>;

export default Icon;



// WEBPACK FOOTER //
// ./src/options/icons/Connect.jsx